import axios, { AxiosResponse } from 'axios';
import useUser from './useUser';

import { URL_PRODUCTS_IM } from 'constants/url';
import { IProductForm } from 'interfaces/imProducts.interface';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';

export default function useProductsIM() {
  const { jwt } = useUser();
  const headers = {
    Authorization: `Bearer ${jwt}`
  };

  const getProductsInventory = (
    page: number,
    rowsPerPage: number,
    search: {
      sku: string;
      fecha: MaterialUiPickersDate;
    },
    download = false
  ): Promise<any> => {
    return axios
      .get(
        `${URL_PRODUCTS_IM}/getAllBySku?download=${download}&pageSize=${rowsPerPage}&page=${page}&search=${JSON.stringify(
          search
        )}`,
        {
          headers
        }
      )
      .then((result: AxiosResponse) => {
        return result.data;
      });
  };
  const getProducts = (page: number, rowsPerPage: number, search: string): Promise<any> => {
    return axios
      .get(`${URL_PRODUCTS_IM}?pageSize=${rowsPerPage}&page=${page}&search=${search}`, { headers })
      .then((result: AxiosResponse) => {
        return result.data;
      });
  };
  const getXLSX = (sku: string, initialDate: Date, endDate: Date): Promise<any> => {
    return axios
      .get(`${URL_PRODUCTS_IM}/xlsx-movements?sku=${sku}&initialDate=${initialDate}&endDate=${endDate}`, { headers })
      .then((result: AxiosResponse) => {
        return result.data;
      });
  };
  const getProductById = (productId: string): Promise<any> => {
    return axios.get(`${URL_PRODUCTS_IM}/${productId}`, { headers }).then((result: AxiosResponse) => {
      if (result.status === 200) {
        return result.data;
      } else {
        return null;
      }
    });
  };

  const updateProduct = (data: IProductForm, productId: string): Promise<boolean> => {
    if (!productId) throw new Error('El campo id es obligatorio');
    return axios.post(`${URL_PRODUCTS_IM}/${productId}`, data, { headers }).then((response: AxiosResponse) => {
      return response.status === 201;
    });
  };

  return {
    getProducts,
    getProductById,
    updateProduct,
    getProductsInventory,
    getXLSX
  };
}
